// Conversation Templates - Các mẫu hội thoại nhanh theo chủ đề

export const CHAT_TEMPLATES = {
  // HR Templates
  hr_overview: {
    id: 'hr_overview',
    category: 'hr',
    title: 'Tổng quan nhân sự',
    icon: 'fa-users',
    description: 'Xem tổng quan tình hình nhân sự toàn công ty',
    prompt: 'Cho tôi tổng quan tình hình nhân sự hiện tại: số lượng nhân viên theo phòng ban, tỷ lệ đi đúng giờ, hợp đồng sắp hết hạn, và các rủi ro nhân sự cần chú ý.',
    color: '#2f6bd8',
  },
  salary_analysis: {
    id: 'salary_analysis',
    category: 'hr',
    title: 'Phân tích lương',
    icon: 'fa-money-bill-wave',
    description: 'Phân tích quỹ lương và chi phí nhân sự',
    prompt: 'Phân tích quỹ lương tháng này: tổng quỹ lương theo phòng ban, nhân viên có lương cao nhất/thấp nhất, so sánh với tháng trước, và các khoản phúc lợi đang chi.',
    color: '#be2d6a',
  },
  attendance_report: {
    id: 'attendance_report',
    category: 'hr',
    title: 'Báo cáo chấm công',
    icon: 'fa-fingerprint',
    description: 'Thống kê chấm công, đi muộn, về sớm',
    prompt: 'Cho tôi báo cáo chấm công tháng này: tỷ lệ đi đúng giờ, danh sách nhân viên đi muộn nhiều nhất, số lần về sớm, và so sánh với tháng trước.',
    color: '#136c34',
  },
  contract_alerts: {
    id: 'contract_alerts',
    category: 'hr',
    title: 'Cảnh báo hợp đồng',
    icon: 'fa-file-contract',
    description: 'Kiểm tra hợp đồng lao động sắp hết hạn',
    prompt: 'Kiểm tra các hợp đồng lao động sắp hết hạn trong 30 ngày tới. Liệt kê chi tiết: tên nhân viên, phòng ban, loại hợp đồng, ngày hết hạn, số ngày còn lại.',
    color: '#b45309',
  },
  leave_summary: {
    id: 'leave_summary',
    category: 'hr',
    title: 'Tình hình nghỉ phép',
    icon: 'fa-calendar-minus',
    description: 'Thống kê đơn nghỉ phép và số dư phép',
    prompt: 'Cho tôi tình hình nghỉ phép tháng này: tổng số đơn nghỉ, tỷ lệ duyệt/từ chối, nhân viên nghỉ nhiều nhất, và danh sách người sắp hết phép năm.',
    color: '#2894ae',
  },
  recruitment_status: {
    id: 'recruitment_status',
    category: 'hr',
    title: 'Tình hình tuyển dụng',
    icon: 'fa-user-plus',
    description: 'Cập nhật tiến độ tuyển dụng',
    prompt: 'Cập nhật tình hình tuyển dụng hiện tại: vị trí đang mở, số ứng viên mỗi vị trí, số lịch phỏng vấn sắp tới, và tỷ lệ chuyển đổi từ ứng viên -> phỏng vấn -> nhận việc.',
    color: '#6d5ae0',
  },
  employee_evaluation: {
    id: 'employee_evaluation',
    category: 'hr',
    title: 'Đánh giá nhân viên',
    icon: 'fa-star',
    description: 'Kết quả đánh giá hiệu suất nhân viên',
    prompt: 'Cho tôi kết quả đánh giá hiệu suất nhân viên tháng này: điểm trung bình, phân loại xếp loại, nhân viên xuất sắc nhất, và nhân viên cần cải thiện.',
    color: '#dc2626',
  },
  performance_trend: {
    id: 'performance_trend',
    category: 'hr',
    title: 'Xu hướng hiệu suất',
    icon: 'fa-chart-line',
    description: 'Phân tích xu hướng hiệu suất theo thời gian',
    prompt: 'Phân tích xu hướng hiệu suất làm việc của nhân viên trong 6 tháng gần đây: ai tăng, ai giảm, dự đoán xu hướng tiếp theo, và đề xuất hành động.',
    color: '#0e9ab8',
  },

  // Vehicle Templates
  vehicle_overview: {
    id: 'vehicle_overview',
    category: 'vehicle',
    title: 'Tổng quan đội xe',
    icon: 'fa-car',
    description: 'Tình trạng toàn bộ đội xe',
    prompt: 'Cho tôi tổng quan đội xe hiện tại: tổng số xe theo trạng thái, xe đang hoạt động, xe đang bảo trì, xe nghỉ, và các xe sắp hết hạn đăng kiểm/bảo hiểm.',
    color: '#2f6bd8',
  },
  vehicle_maintenance: {
    id: 'vehicle_maintenance',
    category: 'vehicle',
    title: 'Lịch bảo dưỡng xe',
    icon: 'fa-wrench',
    description: 'Kiểm tra lịch bảo dưỡng xe',
    prompt: 'Kiểm tra các xe cần bảo dưỡng: xe nào đã đến lịch bảo dưỡng, xe nào đã bảo trì gần đây, chi phí bảo trì trung bình mỗi xe, và dự đoán lần bảo dưỡng tiếp theo.',
    color: '#d97706',
  },
  fuel_analysis: {
    id: 'fuel_analysis',
    category: 'vehicle',
    title: 'Phân tích nhiên liệu',
    icon: 'fa-gas-pump',
    description: 'Phân tích mức tiêu thụ nhiên liệu',
    prompt: 'Phân tích mức tiêu thụ nhiên liệu của đội xe tháng này: xe nào tiêu thụ nhiều nhất, chi phí nhiên liệu trung bình/km, so sánh giữa các xe, và gợi ý tiết kiệm nhiên liệu.',
    color: '#ef4444',
  },
  vehicle_cost: {
    id: 'vehicle_cost',
    category: 'vehicle',
    title: 'Chi phí phương tiện',
    icon: 'fa-file-invoice-dollar',
    description: 'Tổng hợp chi phí xe (xăng, bảo trì, sửa chữa)',
    prompt: 'Tổng hợp tất cả chi phí liên quan đến đội xe: xăng dầu, bảo dưỡng, sửa chữa, phí đường bộ, bảo hiểm. Phân tích theo tháng và theo xe, chỉ ra xe có chi phí cao nhất.',
    color: '#8b7bf0',
  },
  driver_schedule: {
    id: 'driver_schedule',
    category: 'vehicle',
    title: 'Lịch tài xế',
    icon: 'fa-id-card',
    description: 'Xem lịch phân công tài xế',
    prompt: 'Cho tôi lịch phân công tài xế hiện tại: ai đang lái xe nào, lịch trình trong tuần tới, tài xế nào đang nghỉ, và gợi ý phân công tối ưu.',
    color: '#15803d',
  },

  // Work Management Templates
  work_summary: {
    id: 'work_summary',
    category: 'work',
    title: 'Tổng hợp công việc',
    icon: 'fa-tasks',
    description: 'Thống kê tình hình công việc',
    prompt: 'Tổng hợp tình hình công việc hiện tại: tổng số việc đang làm, đã hoàn thành, quá hạn, tiến độ trung bình, dự án nào đang có nhiều việc nhất, và việc nào cần ưu tiên xử lý ngay.',
    color: '#0e9ab8',
  },
  overdue_tasks: {
    id: 'overdue_tasks',
    category: 'work',
    title: 'Việc quá hạn',
    icon: 'fa-exclamation-triangle',
    description: 'Danh sách công việc quá hạn cần xử lý',
    prompt: 'Liệt kê tất cả công việc đã quá hạn nhưng chưa hoàn thành: tên việc, người phụ trách, ngày đến hạn, số ngày quá hạn, và mức độ ưu tiên xử lý.',
    color: '#dc2626',
  },
  project_progress: {
    id: 'project_progress',
    category: 'work',
    title: 'Tiến độ dự án',
    icon: 'fa-project-diagram',
    description: 'Theo dõi tiến độ từng dự án',
    prompt: 'Báo cáo tiến độ tất cả dự án hiện tại: tên dự án, số việc đã hoàn thành/tổng số, tỷ lệ %, người phụ trách chính, dự đoán ngày hoàn thành, và rủi ro chậm tiến độ.',
    color: '#4c85e3',
  },

  // Personal Templates
  my_work: {
    id: 'my_work',
    category: 'personal',
    title: 'Công việc của tôi',
    icon: 'fa-clipboard-list',
    description: 'Xem công việc được giao',
    prompt: 'Cho tôi biết tất cả công việc hiện tại của tôi: việc đang làm, việc quá hạn, việc sắp đến hạn, tiến độ từng việc, và gợi ý thứ tự ưu tiên xử lý.',
    color: '#14b8a6',
  },
  my_attendance: {
    id: 'my_attendance',
    category: 'personal',
    title: 'Chấm công của tôi',
    icon: 'fa-clock',
    description: 'Xem thống kê chấm công cá nhân',
    prompt: 'Thống kê chấm công của tôi tháng này: số ngày đi làm, số lần đi muộn, số lần về sớm, tổng giờ làm, so sánh với quy định, và số ngày phép còn lại.',
    color: '#8dca2f',
  },
};

// Smart Contextual Suggestions - Gợi ý thông minh dựa trên ngữ cảnh
export const getContextSuggestions = (role, timeOfDay, dayOfWeek, month, dataContext = {}) => {
  const suggestions = [];

  // Morning suggestions
  if (timeOfDay >= 7 && timeOfDay < 10) {
    suggestions.push({
      q: 'Hôm nay có lịch họp nào?',
      label: 'Lịch họp hôm nay',
      icon: 'fa-calendar',
    });
    if (role !== 'EMPLOYEE') {
      suggestions.push({
        q: 'Ai chưa điểm danh sáng nay?',
        label: 'Chưa điểm danh',
        icon: 'fa-user-clock',
      });
    }
  }

  // End of day suggestions
  if (timeOfDay >= 16) {
    suggestions.push({
      q: 'Hôm nay có việc nào chưa hoàn thành?',
      label: 'Việc chưa xong',
      icon: 'fa-hourglass-half',
    });
  }

  // Monday suggestions
  if (dayOfWeek === 1) {
    suggestions.push({
      q: 'Kế hoạch công việc tuần này?',
      label: 'Kế hoạch tuần',
      icon: 'fa-calendar-week',
    });
  }

  // Friday suggestions
  if (dayOfWeek === 5) {
    suggestions.push({
      q: 'Tổng kết công việc tuần này?',
      label: 'Tổng kết tuần',
      icon: 'fa-clipboard-check',
    });
    suggestions.push({
      q: 'Báo cáo tuần này có gì nổi bật?',
      label: 'Nổi bật tuần này',
      icon: 'fa-chart-bar',
    });
  }

  // End of month suggestions
  if (month >= 25 || month <= 5) {
    if (role === 'ACCOUNTANT' || role === 'ADMIN' || role === 'SUPER_ADMIN') {
      suggestions.push({
        q: 'Chuẩn bị chốt lương tháng này?',
        label: 'Chốt lương',
        icon: 'fa-calculator',
      });
    }
  }

  // Data-driven suggestions
  if (dataContext.expiringContracts > 0) {
    suggestions.push({
      q: `${dataContext.expiringContracts} hợp đồng sắp hết hạn, xử lý sao?`,
      label: 'Hợp đồng sắp hết',
      icon: 'fa-file-contract',
    });
  }

  if (dataContext.overdueTasks > 3) {
    suggestions.push({
      q: 'Có nhiều việc quá hạn, ưu tiên xử lý sao?',
      label: 'Việc quá hạn',
      icon: 'fa-exclamation-circle',
    });
  }

  if (dataContext.vehicleExpiring > 0) {
    suggestions.push({
      q: `${dataContext.vehicleExpiring} xe sắp hết hạn đăng kiểm/bảo hiểm?`,
      label: 'Xe sắp hết hạn',
      icon: 'fa-car',
    });
  }

  if (dataContext.fuelCostHigh) {
    suggestions.push({
      q: 'Chi phí xăng dầu tháng này tăng cao, phân tích nguyên nhân?',
      label: 'Xăng dầu tăng',
      icon: 'fa-gas-pump',
    });
  }

  // Default suggestions if nothing specific
  if (suggestions.length === 0) {
    suggestions.push({
      q: 'Tôi cần giúp gì hôm nay?',
      label: 'Gợi ý cho tôi',
      icon: 'fa-lightbulb',
    });
  }

  return suggestions.slice(0, 4); // Max 4 suggestions
};

export default CHAT_TEMPLATES;
